import moment from "moment";

/**
 * COS/AH case note delivered date picker bounds.
 * Not expired (end_date on or after today): no min/max — open calendar (matches backend).
 * Expired: contract window, capped at today (no future delivered dates).
 *
 * @param {object|null|undefined} funding
 * @returns {{ minDate?: Date, maxDate?: Date, open: boolean }}
 */
export function getFundingDeliveredDatePickerBounds(funding) {
  if (!funding?.start_date || !funding?.end_date) {
    return { minDate: undefined, maxDate: undefined, open: false };
  }
  const start = moment(funding.start_date).startOf("day");
  const end = moment(funding.end_date).startOf("day");
  const today = moment().startOf("day");

  const expired = end.isBefore(today, "day");

  if (!expired) {
    return {
      minDate: undefined,
      maxDate: undefined,
      open: true,
    };
  }

  return {
    minDate: start.toDate(),
    maxDate: moment.min(end, today).toDate(),
    open: false,
  };
}

/**
 * Default delivered date for new case notes (today, clamped to funding bounds).
 *
 * @param {{ minDate?: Date, maxDate?: Date }} bounds
 * @returns {Date}
 */
export function getDefaultDeliveredDate(bounds = {}) {
  const today = moment().startOf("day");
  const min = bounds.minDate ? moment(bounds.minDate).startOf("day") : null;
  const max = bounds.maxDate ? moment(bounds.maxDate).startOf("day") : null;

  if (min && today.isBefore(min, "day")) {
    return min.toDate();
  }
  if (max && today.isAfter(max, "day")) {
    return max.toDate();
  }
  return today.toDate();
}
